import React from "react";
import "./ProfileCard.css";
import WalletActions from "../WalletActions/WalletActions";
import { useNavigate } from "react-router-dom";

function ProfileCard() {
  const navigate = useNavigate();
  return (
    <>
      <section className="ProfileCard">
        <div className="profile-card">
          <div className="profile-header">
            <img
              src="https://i.pravatar.cc/100"
              alt="profile"
              className="profile-img"
            />
            <div className="profile-info">
              <h4>MEMBERNNG60JIT</h4>
              <p>UID | 1547870</p>
              <span>Last login 2025-02-11 11:34:56</span>
            </div>
          </div>
          <div className="balence_box_holder">
            <div className="balance-box">
              <div>
                <p>Total Balance</p>
                <h3>₹345.00</h3>
              </div>
              <button className="wallet-btn" onClick={() => navigate("/wallet")}>Enter Wallet</button>
            </div>
            <WalletActions />
          </div>
        </div>
      </section>
    </>
  );
}

export default ProfileCard;
